var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab

function showTab(n) {
  var x = document.getElementsByClassName("less-opacity");
  if (x[n]) {
    x[n].style.cssText = "opacity: 1; pointer-events: all";
  }
}

function nextPrev(n) {
  var x = document.getElementsByClassName("less-opacity");
  if (n == 1 && !validateForm()) return false;
  //x[currentTab].style.display = "none";
  currentTab = currentTab + n;
  if (currentTab >= x.length) {
    console.log("completed");
    document.getElementById("Addbuttons").classList.remove("less_opacity");
    const sub_time = document.getElementById("only_subscription");
    if (sub_time) {
      sub_time.classList.remove("less_opacity");
    }
    return false;
  }
  showTab(currentTab);
}

function validateForm() {
  var x,
    y,
    i,
    valid = true;
  x = document.getElementsByClassName("less-opacity");
  if (x[currentTab]) {
    y = x[currentTab].getElementsByTagName("input");
    //console.log(x[currentTab]);
    for (i = 0; i < y.length; i++) {
      if (y[i].checked == true) {
        return valid; // return the valid status
      }
    }
    valid = false;
  }
}

var elements = document.getElementsByClassName("step_function");

// Products that only have the Grind/Weight variant picker (step_1, which
// isn't a .step_function step - only the metafield-driven Beans/Drink-type
// blocks are) have no clickable steps at all here, so nextPrev() - the only
// thing that reveals #Addbuttons - would never run and Add to cart would
// stay faded and unclickable (pointer-events: none) forever. Reveal it
// immediately in that case since there's nothing left to click through.
if (elements.length === 0) {
  var addButtons = document.getElementById("Addbuttons");
  if (addButtons) addButtons.classList.remove("less_opacity");
  var subTime = document.getElementById("only_subscription");
  if (subTime) subTime.classList.remove("less_opacity");
}

var myFunction = function () {
  //console.log(this);
  if ($(this).hasClass("sub_dropdown_box")) {
    var $radioButtons = $('.sub_dropdown_box input[type="radio"]');

    $radioButtons.click(function () {
      $radioButtons.each(function () {
        $(this).parent().parent().toggleClass("active-purchase", this.checked);
      });
    });

    if ($(".subscription_box").hasClass("active-purchase")) {
      $(".subscription-time").removeClass("hidden");
    } else {
      $(".subscription-time").addClass("hidden");
    }

    subsLineItems();
  }

  if ($(this).hasClass("Beans")) {
    var $beansradioButtons = $('.beans-radio-wrapper input[type="radio"]');
    //var $step3 = $(".step_3");
    var $step3 = $(".step_3:not(.hidden-exemption)");


    $beansradioButtons.click(function () {
      $beansradioButtons.each(function () {
        $(this).parent().toggleClass("active-beantype", this.checked);
      });
    });

    if ($(".beans_wrapper:nth-child(2)").hasClass("active-beantype")) {
      $step3.removeClass("hidden");
      $step3.css({ opacity: "1", "pointer-events": "all" });
      $step3.find(".drink_type_wrapper:first-child input").prop("checked", true);
    } else {
      $step3.addClass("hidden");
      $step3.find("input[name='properties[Drink Type]']").prop("checked", false);
    }
  }
  nextPrev(1);
};

for (var i = 0; i < elements.length; i++) {
  elements[i].addEventListener("click", myFunction, false);
}